<template>
  <div id="app">
  <b-navbar toggleable="lg" sticky="true">
    <b-navbar-brand href="/"><img alt="Wetwall Logo" src="./assets/wetwall-logo-trimmed.png" width="150"></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item href="designs">Designs</b-nav-item>

        <b-nav-item href="gallery">Gallery</b-nav-item>

        <b-nav-item href="installation">Installation</b-nav-item>

        <b-nav-item href="where-to-buy">Where to Buy</b-nav-item>

        <b-nav-item href="resources">Resources</b-nav-item>

        <b-nav-item href="contact">Contact</b-nav-item>

        <!--
        <b-nav-item-dropdown text="Resources">

          <b-nav-item href="technical-specifications">Technical Specifications</b-nav-item>
        </b-nav-item-dropdown>

        <b-nav-item href="faqs">FAQs</b-nav-item>
        <b-nav-item href="contacts">Contacts</b-nav-item>
      -->


      </b-navbar-nav>
    </b-collapse>

    <div id="uk-site">
      <a href="https://wetwall.co.uk/">UK Site <b-img src="./assets/img/uk-flag.svg" ></b-img></a>
    </div>
  </b-navbar>

  <router-view></router-view>

  <div id="footer">
    Copyright © 2020 Wilsonart LLC. All Rights Reserved. | <a href="https://www.wilsonart.com/privacy-policy" target="_blank">Privacy Policy</a> | <a href="https://www.wilsonart.com/terms-use" target="_blank">Terms of Use</a>
  </div>

    <b-modal id="uk-1" ref="video-1" centered hide-footer busy="true" modalClass="ww-video-modal">
      <template v-slot:default="">
        <b-container class="">
          <b-row>
            <b-col>
              <div style="text-align: center;">
                Looks like you are from the UK. Visit our UK site?<br /><br />

                <div class="ww-button-block">
                  <a v-on:click="visitUK">Yes</a>

                  <a v-on:click="stayUS">No</a>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  },

  methods: {
    visitUK() {
      window.location.replace("https://wetwall.co.uk/");
    },

    stayUS() {
      this.$root.$emit('bv::hide::modal', 'uk-1');

      if (!localStorage.stay) {
        localStorage.stay = true;
      }
    }
  },

  mounted () {
    if (this.$route.query.visit == 'uk') { localStorage.stay = true; }

    if (localStorage.stay === undefined) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://www.cloudflare.com/cdn-cgi/trace');
      xhr.send(null);

      //var vm = this;

      xhr.onreadystatechange = function () {
        var DONE = 4; // readyState 4 means the request is done.
        var OK = 200; // status 200 is a successful return.
        if (xhr.readyState === DONE) {
          if (xhr.status === OK) {
            // console.log(xhr.responseText); // 'This is the returned text.'

            var location = xhr.responseText.match(/loc=(.+)/)[1];

            var countries = new Array("AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PO","PT","RO","SK","SI","ES","SE","AL","AD","AM","BY","BA","FO","GE","GI","IS","IM","XK","LI","MK","MD","MC","ME","NO","RU","SM","RS","CH","TR","UA","GB","VA","UK");

            if (countries.includes(location.toUpperCase())) {
              //vm.$root.$emit('bv::show::modal', 'uk-1');
              //console.log(vm);
              window.location.replace("https://wetwall.co.uk/");
            }


          } else {
            console.log('Error: ' + xhr.status); // An error occurred during the request.
          }
        }
      };
    }
  }
}
</script>

<style lang="scss">
body {
  color: #231F20;
  font-family: 'PT Sans', sans-serif;

  .navbar {
    padding: 0;
    background-color: #fff;
    border-bottom: 1px solid #000;

    .navbar-brand {
      padding: 15px 0;
      padding-left: 20px;
    }

    #nav-collapse {


      @media (min-width: 768px) {
        justify-content: flex-end;
        margin-top: 30px;
      }

    }

    .navbar-toggler {
      margin-top: 22px;
      border: 0;
      color: #231F20 !important;
    }

    #uk-site {
      position: absolute;
      top: 10px;
      right: 10px;
      font-family: 'Montserrat', sans-serif;
      color: #231F20 !important;
      font-size: .8rem;
      font-weight: bold;
      text-transform: uppercase;

      a {
        color: #231F20;
      }

      img {
        margin-top: -3px;
        width: 26px;
        height: auto;
      }
    }
  }

  h1, h2, h3, h4 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    text-transform: uppercase;
  }

  h1 {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.5rem;
    letter-spacing: .15em;
    font-weight: 600;
    margin-bottom: 20px;
  }

  h4 {
    font-family: 'Montserrat', sans-serif;
    font-size: .8em;
    letter-spacing: .5em;
    font-weight: 700;
    margin-bottom: 3px;

    &.exclusively {
      letter-spacing: .2em;

      img {
        height: 35px;
        width: auto;
      }
    }
  }

  h5, .h5 {
      font-size: 1rem;
  }

  p.subhead {
    font-family: 'Montserrat', sans-serif;
  }


  .icon-section {
    text-align: left;

    .row {
      margin-bottom: 20px;
    }

    .icon {
      flex-grow: 0;

      img {
        max-width: 60px;
        height: auto;
      }

    }

    .text {
      align-items: center;
      display: flex;
      flex-grow: 1;
    }

  }

  .embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; }
  .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  #app {
    text-align: center;

    .wetwall-item {
      margin-bottom: 20px;

      img {
        border-radius: 20px;
        margin-bottom: 20px;
      }

      a {
        color: #231F20;
        display: inline-block;
        cursor: pointer;

        &:hover {
          color: #231F20;

          img {
            transition: .4s;
            -webkit-box-shadow: 10px 10px 24px -16px rgba(0,0,0,0.75);
            -moz-box-shadow: 10px 10px 24px -16px rgba(0,0,0,0.75);
            box-shadow: 10px 10px 24px -16px rgba(0,0,0,0.75);
          }
        }
      }
    }
  }

  #carousel-1 {
    .carousel-item {
      max-height: 400px;
    }
  }

  .carousel-caption {
    padding: 0;
    top: 0;
    bottom: 0;
    align-items: center;
    display: flex;
    justify-content: center;

    .play {
      width: 75px;
      height: 75px;
      stroke-width: 2px;
    }
  }

  #carousel-modal {
    background: transparent !important;
  }

  .video-slide {
    background: transparent !important;

    .carousel-caption {
      left: 0;
      right: 0;
    }

    .video-slide-button {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .bg {


    }

    .slide-inner {
      width: 100%;
      height: 0;
      padding-top: 56.25%;
      position: relative;

      .embed-responsive {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
      }
    }


  }

  .carousel-indicators li {
    width: 12px;
    height: 12px;
    border-radius: 50px;
    display: block;
    border: 2px solid #231F20;
    background-color: transparent;
    opacity: 1;

    &.active {
      background-color: #231F20;
    }
  }

  .navbar-nav {
    .nav-item {
      margin-left: 1em;
      margin-right: 1em;
    }
    a {
      font-family: 'Montserrat', sans-serif;
      color: #231F20 !important;
      font-size: .7rem;
      letter-spacing: .5em;
      font-weight: bold;
      text-transform: uppercase
    }

    .dropdown-menu {
      text-align: center;
    }
  }

  input.form-control {
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid black;
  }

  .ww-section {
    margin-top: 3rem;
    margin-bottom: 3rem;

    h4:first-child {
      margin-top: 0;
    }
  }

  .exclusively {

  }

  .store-list {
    a {
      color: inherit;

      &:hover {
        text-decoration: none;
      }
    }

    .name {
      font-family: 'Montserrat', sans-serif;
      font-size: .8rem;
      letter-spacing: .2em;
      text-transform: uppercase;
      font-weight: bold;
    }
  }

  .ww-button-block {
    a {
      display: inline-block;
      margin-left: 10px;
      margin-right: 10px;
      font-family: 'Montserrat', sans-serif;
      font-size: .8rem;
      letter-spacing: .2em;
      text-transform: uppercase;
      border: 2px solid #231F20;
      border-radius: 30px;
      padding: 8px 20px;
      color: #231F20;
      transition: .4s;
      margin-bottom: 20px;
      cursor: pointer;

      &:hover {
        background-color: #231F20;
        color: #fff;
        text-decoration: none;
      }
    }
  }

  .contact-form {
    label {
      font-family: 'Montserrat', sans-serif;
      font-size: .8rem;
      letter-spacing: .2em;
      width: 100%;
      text-align: right;
    }

    .ww-button-block {
      text-align: right;

      a {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }

  #modal-sku.modal.show {
    .modal-dialog {
      max-width: 1024px;

      .modal-header {
        border: 0;
        padding-bottom: 0;
      }

      .modal-body {
        padding-bottom: 40px;

        .name {
          margin-bottom: 0;
        }

        .sku {
          margin-bottom: 30px;
        }
      }

      .ww-section {
        margin-top: 0;
      }
    }
  }

  .ww-video-modal.modal.show {
    .modal-dialog {
      max-width: 1024px;

      .modal-header {
        border: 0;
        padding-bottom: 0;
      }

      .modal-body {
        padding-bottom: 40px;

        .name {
          margin-bottom: 0;
        }

        .sku {
          margin-bottom: 30px;
        }
      }

      .ww-section {
        margin-top: 0;
      }
    }
  }

  i.arrow {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 6px;

    &.right {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }

    &.left {
      transform: rotate(135deg);
      -webkit-transform: rotate(135deg);
    }

    &.up {
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
    }

    &.down {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
  }

  #footer {
    padding: 50px 0;
    background-color: #E6E6E6;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    font-size: .75rem;
    letter-spacing: .3em;

    a {
      color: #2c3e50;
    }
  }

}
</style>
